export const updateProductPrice = () => {
  jQuery(document).ready(function ($) {
    $("form.variations_form").on(
      "found_variation",
      function (event, variation) {
        if (variation && variation.price_html) {
          const tmp = document.createElement('div');
          tmp.innerHTML = variation.price_html;
          tmp.querySelectorAll('.seba-wc-omnibus').forEach(el => el.remove());
          $(".woocommerce-variation-price").html(tmp.innerHTML);
        }
      }
    );
  });
};
